module.exports = __webpack_public_path__ + "img/product-background.7714d3ae.png";